module.exports = __webpack_public_path__ + "img/social.a78d8b98.svg";